// extracted by mini-css-extract-plugin
export default {"mainThumb":"Band_mainThumb__bKvKO"};